"use client";

import type { ILink } from "@components/core/Link";
import type React from "react";

import { Link } from "@components/core/Link";
import { cn } from "@ui/lib/utils";

interface AnchorLinksProps {
  className?: string;
  links?: ILink[];
}

const AnchorLinks = ({ links, className }: AnchorLinksProps) => {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = e.currentTarget.getAttribute("href")?.split("#")[1];
    if (!target) return;
    const element = document.getElementById(target);
    if (element) {
      window.scrollTo({
        behavior: "smooth",
        top: element.offsetTop - 100,
      });
      window.history.pushState(null, "", `#${target}`);
    }
  };

  return (
    links &&
    links?.length > 0 && (
      <ul className={cn("flex flex-wrap gap-8", className)}>
        {links?.map(({ appearance, ...rest }, index) => (
          <li key={index}>
            <Link asButton buttonVariants={{ variant: appearance || "elevated" }} onClick={onClick} {...rest} />
          </li>
        ))}
      </ul>
    )
  );
};

AnchorLinks.displayName = "AnchorLinks";

export { AnchorLinks };
